import React from 'react'

const Venue = () => (
  <section className="ts-map-direction">
    <a id="venue" className="anchor" />
    <div className="container">
      <div className="row">
        <div className="col-lg-4">
          <h2 className="column-title">
            <span>Venue</span>
            会場案内
          </h2>

          <div className="ts-map-tabs">
            <div className="tab-content direction-tabs">
              <div role="tabpanel" className="tab-pane active" id="profile">
                <div className="direction-tabs-content">
                  <h3>豊洲フロント</h3>
                  <p className="derecttion-vanue">
                    東京都江東区豊洲３丁目２−２０
                    <br />
                    東京メトロ有楽町線 「豊洲駅」 徒歩1分
                    <br />
                    1c出口 右側に直結エスカレーターあり
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="col-lg-7 offset-lg-1">
          <div className="ts-map">
            <div className="mapouter">
              <div className="gmap_canvas">
                <iframe
                  src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3241.813663832686!2d139.79335265081778!3d35.65696228010278!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x601889a1836ae1d3%3A0xe136a96dfae2bbc9!2z6LGK5rSy44OV44Ot44Oz44OI!5e0!3m2!1sja!2sjp!4v1573963592381!5m2!1sja!2sjp"
                  frameBorder="0"
                  allowFullScreen=""
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>
)

export default Venue
